import { motion } from "framer-motion";
import { translations, type Lang } from "../content";

/*
 * The reference's stat band. Content is unchanged - these are the same four
 * feature lines that previously sat inside the About section.
 */
export default function Features({ lang }: { lang: Lang }) {
  const t = translations[lang].features;

  return (
    <section className="relative border-t border-b border-border/10">
      <div className="container mx-auto px-6 md:px-10" dir={lang === "he" ? "rtl" : "ltr"}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y divide-border/10 lg:divide-y-0 lg:divide-x rtl:lg:divide-x-reverse lg:divide-border/10">
          {t.items.map((item, i) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="py-10 lg:py-14 px-0 lg:px-8 first:ltr:lg:pl-0 first:rtl:lg:pr-0"
            >
              <p className="display-lg text-2xl md:text-3xl text-foreground">{item}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
